import BasePanelLayout, { type PanelColorScheme } from "@/components/BasePanelLayout";
import { ShieldCheck } from "lucide-react";
import { adminNav } from "@/config/navigation";

const adminColors: PanelColorScheme = {
  activeBg: "bg-primary/10",
  activeText: "text-primary",
  border: "border-border",
  mobileActive: "border-primary text-primary",
};

function AdminSidebarHeader(collapsed: boolean) {
  return (
    <div className="flex items-center gap-2 overflow-hidden">
      <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center shrink-0">
        <ShieldCheck className="h-4 w-4 text-primary-foreground" />
      </div>
      {!collapsed && (
        <span className="text-sm font-bold text-foreground whitespace-nowrap">Admin Panel</span>
      )}
    </div>
  );
}

function AdminMobileHeader() {
  return (
    <>
      <ShieldCheck className="h-5 w-5 text-primary" />
      <span className="font-bold text-sm">Admin</span>
    </>
  );
}

export default function AdminLayout() {
  return (
    <BasePanelLayout
      navConfig={adminNav}
      colorScheme={adminColors}
      sidebarHeader={AdminSidebarHeader}
      mobileHeader={<AdminMobileHeader />}
    />
  );
}
